function decodeEmails() {
  var $encodedUrls = document.querySelectorAll("a[data-encoded]"), decodedStr;
     if (window.atob && $encodedUrls.length) {
         for (var i = 0; i< $encodedUrls.length; i++) {
	         decodedStr=atob($encodedUrls[i].getAttribute('data-encoded'));
	         if (location.href.indexOf('eurobookings.com') != -1) {
		         decodedStr = decodedStr.replace('@hotelsone.com', '@eurobookings.com');
	         } else if (location.href.indexOf('hotelsone.com') != -1) {
		         decodedStr = decodedStr.replace('@eurobookings.com', '@hotelsone.com');
	         }
             $encodedUrls[i].setAttribute('href', decodedStr);
	         if (decodedStr.indexOf('mailto:') != -1) {
  	             $encodedUrls[i].textContent = decodedStr.substr(7);
	         }
      }
  }
}